module.exports = __webpack_public_path__ + "img/bg_mnjy_zhang@2x.50dc5ddd.png";